import { ContractorSchema } from "@/services/api/contractor/contracts";
import { z } from "zod";

export const LoggedInUserResponseSchema = z.object({
  Id: z.number(),
  UserName: z.string(),
  Email: z.string(),
  FullName: z.string(),
  Mobile: z.string(),
  OfficePhone: z.string().optional(),
  Contractor: ContractorSchema,
});

export const ContactPersonSchema = z.object({
  Id: z.number(),
  FocalPointName: z.string(),
  Email: z.string(),
  Phone: z.string(),
  UnifiedId: z.string(),
  ContractorId: z.number(),
  LastLoginDateTime: z.string().or(z.date()),
});

export const ContactPersonResponseSchema = z.object({
  FocalPoints: z.array(ContactPersonSchema),
});

export interface LoggedInUserPayload {
  email: string;
}

export interface LoggedInUserNotFlatResponse {
  Data: LoggedInUserResponse;
  Success: boolean;
  Code: number;
  Message: string[];
}

export type LoggedInUserResponse = z.infer<typeof LoggedInUserResponseSchema>;

export type ContactPerson = z.infer<typeof ContactPersonSchema>;

export type ContactPersonResponse = z.infer<typeof ContactPersonResponseSchema>;
